import { Box, Stack } from "@mui/material";
import { FC, Suspense } from "react";
import type { MainLayoutProps } from "../lib/type";
import { FooterFetchWrapper } from "./FooterFetchWrapper";
import { HeaderFetchWrapper } from "./HeaderFetchWrapper";
import { TextUsModal } from "@/src/components/Modals";
import dynamic from "next/dynamic";

const FieldDetailInfoModalClientWrapper = dynamic(
  () =>
    import(
      "@/src/components/Modals/components/FieldDetailInfoModal/FieldDetailInfoModalClientWrapper"
    ),
  { ssr: false },
);

export const NavLayout: FC<MainLayoutProps> = ({ children }) => {
  return (
    <Stack className={"flex min-h-screen flex-col bg-super-light-gray"}>
      <HeaderFetchWrapper />
      <Box component={"main"} flex={1}>
        {children}
        <Suspense fallback={<div />}>
          <TextUsModal />
        </Suspense>
        <FieldDetailInfoModalClientWrapper />
      </Box>
      <FooterFetchWrapper />
    </Stack>
  );
};
